var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('item-despesa',{attrs:{"item":_vm.item}},[_c('template',{slot:"footer"},[_c('app-btn-voltar',{attrs:{"rota":"DespesasGerais_Financeiro_Despesas_Detalhar"}})],1)],2),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }